module.exports = __webpack_public_path__ + "static/media/CLASS.1c0e73c9.jpg";